// ----------------------------------------------------------------------

const account = {
  displayName: 'Manager',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;
